import { Component, Input } from '@angular/core';
import { ComplianceData } from '../../../shared/models/compliance-data.model';
import { COMMON_IMPORTS } from '../../../shared/imports/common-imports';
import { ListViewItemComponent } from './list-view-item/list-view-item.component';

@Component({
  selector: 'app-list-view',
  standalone: true,
  imports: [COMMON_IMPORTS, ListViewItemComponent],
  templateUrl: './list-view.component.html',
  styleUrl: './list-view.component.scss',
})
export class ListViewComponent {
  @Input() data: ComplianceData[] = [];
}
